import { STORAGE_URL } from "../constants/consts";

export const fixImageUrl = (
  url: string,
  prefix: string = "attachments/"
): string => {
  if (!url) return "";

  const isBackend = url.startsWith(prefix);

  return isBackend && STORAGE_URL ? `${STORAGE_URL}/storage/${url}` : url;
};
